import { Pipe, PipeTransform } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Pipe({
  name: 'hasChildren',
  standalone: true,
})
export class HasChildrenPipe implements PipeTransform {
  public transform(field: FormlyFieldConfig, triggered = 0): boolean {
    return field?.formControl?.value?.children?.length > 0;
  }
}
